'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdInvertColorsOff = function MdInvertColorsOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 8.5l-3.8 3.8-2.4-2.4 6.2-6.1 9.5 9.4q2.9 3 3.6 7.2t-1 7.8l-12.1-12v-7.7z m0 24.2v-8.1l-8-8q-2 2.7-2 6.1 0 4 3 7t7 3z m14.5 2.1l0.5 0.6-2.1 2.1-4.5-4.5q-3.7 2.9-8.4 2.9-5.6 0-9.5-3.9-3.5-3.6-3.8-8.8t2.9-9l-4.6-4.6 2.1-2.1q23.4 23.4 27.4 27.3z' })
        )
    );
};

exports.default = MdInvertColorsOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/invert-colors-off.js
// module id = 3449
// module chunks = 168707334958949